import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirplay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAirplay"><Path fillRule="evenodd" clipRule="evenodd" d="M2 3H22V18H17.5V16H20V5H4V16H6.5V18H2V3Z" fill="currentColor"/><Path d="M11.9996 13.3984L5.91895 20.9992H18.0802L11.9996 13.3984Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAirplay;
